export default __webpack_public_path__ + "fbdecfce69a96dc73e2ad5dd97d1128c.ttf";